import * as React from "react";
import { CheckboxWithLabel } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
const SaveDetailsToAccount = ({ isChecked = false, onChange }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    CheckboxWithLabel,
    {
      id: "overwritePersonalDetails",
      value: "overwritePersonalDetails",
      checked: isChecked,
      onChange: ({ checked }) => onChange({ isChecked: checked }),
      label: getLabel("checkout.login.express.checkbox")
    }
  );
};
export {
  SaveDetailsToAccount
};
//# sourceMappingURL=SaveDetailsToAccount.js.map
